import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const SelectBox = ({
  label,
  options = [],
  value = [],
  onChange,
  multiple = false,
  showCount = false,
  count = 0,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      const path = event.composedPath(); // Get the path of the clicked element Mostly used for shadow DOM
      const clickedElement = path[0]; // First element is the actual clicked element

      if (dropdownRef.current && !dropdownRef.current.contains(clickedElement)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = optionValue => {
    let newValue;

    if (multiple) {
      if (value.includes(optionValue)) {
        newValue = value.filter(v => v !== optionValue);
      } else {
        newValue = [...value, optionValue];
      }
    } else {
      if (value.includes(optionValue)) {
        newValue = [];
      } else {
        newValue = [optionValue];
      }
      setIsOpen(false);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  const isSelected = optionValue => value.includes(optionValue);
  const hasSelections = value.length > 0;

  return (
    <div ref={dropdownRef} className={`select-box ${multiple ? 'multiselect' : ''}`} {...props}>
      <div
        className={`select-box__button ${hasSelections ? 'isActive' : ''} ${isOpen ? 'select-box__button--clicked' : ''}`}
        onClick={handleToggle}
      >
        <div className="select-box__count-container">
          <span className="select-box__label">{label}</span>
          {showCount && <span className="select-box__count-container">({count})</span>}
        </div>
        {isOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </div>

      <ul className={`select-box__menu ${isOpen ? 'select-box__menu--open' : ''}`}>
        {options.map(option => (
          <li
            key={option.value}
            value={option.label}
            className={`select-box__option ${isSelected(option.value) ? 'select-box__option--active' : ''}`}
            onClick={() => handleOptionClick(option.value)}
          >
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SelectBox;
